import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom'; // <-- Import BrowserRouter
import * as Sentry from "@sentry/react"; // Import Sentry
import { AuthProvider } from './contexts/AuthContext';

// Initialize Sentry as early as possible
Sentry.init({
  dsn: "https://b57069f495aca6c2a903b2d28ad4acb6@o4509350448922624.ingest.us.sentry.io/4509350453248000",
  
  integrations: [
    // Add default integrations:
    Sentry.browserTracingIntegration(), // If you want performance monitoring
    Sentry.replayIntegration(), // If you want session replay
    // For @sentry/react, common integrations are often added by default
    // or you might add specific ones like routing instrumentation if needed.
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0, // For performance monitoring, adjust as needed
  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  replaysSessionSampleRate: 0.1, // For session replay, adjust as needed
  replaysOnErrorSampleRate: 1.0, // For session replay, adjust as needed

  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events.
  // Review Sentry's documentation on PII handling.
  sendDefaultPii: true,

  // You might also want to set environment and release:
  environment: 'QA', // Or process.env.NODE_ENV
  // release: 'my-project-name@1.0.0', // Or dynamically set during build
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* <--- THE ONLY BrowserRouter should be here */}
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
